export function buildCategoryTreeForDropDown(tree, except) {
  if (!tree || !tree.children) return [];
  const reducer = (data, {category, children}) => {
    if (category.categoryId === except) return data;
    data.items.push({...category, name: '·'.repeat(data.level) + category.name});
    data.items.push(...children.reduce(reducer, {items: [], level: data.level + 1}).items);
    return data;
  };
  return tree.children.reduce(reducer, {items: [], level: 0}).items;
}

export function getCategoryAndChildrenIds(tree, categoryId) {
  if (!tree || !tree.children) return [];
  const reducer = (data, {category, children}) => {
    const capture = data.capture || (category.categoryId === categoryId);
    if (capture) data.items.push(category.categoryId);
    data.items.push(...children.reduce(reducer, {items: [], capture}).items);
    return data;
  };
  return tree.children.reduce(reducer, {items: [], capture: false}).items;
}


// WEBPACK FOOTER //
// ./src/Category/tree.js